export const sortBy = (arr, field) => {
    return arr.sort((a, b) => !a[field] || !b[field] ? -1 : (a[[field]].toLowerCase() > b[[field]].toLowerCase()) ? 1 : ((b[[field]].toLowerCase() > a[[field]].toLowerCase()) ? -1 : 0));
}


export const sortByDate = (arr, field) => {
    return arr.sort((a, b) => (a[[field]] > b[[field]]) ? 1 : ((b[[field]] > a[[field]]) ? -1 : 0));
}

export const sortByObjectName = (arr, field, name) => {
    return arr.sort((a, b) => (a[[field]][[name]].toLowerCase() > b[[field]][[name]].toLowerCase()) ? 1 : ((b[[field]][[name]].toLowerCase() > a[[field]][[name]].toLowerCase()) ? -1 : 0));
}

export const checkValue = (obj, defaultValue) => {
    if (obj === undefined || obj === null || obj === "" || obj === "null") return defaultValue
    return obj
}



// WEBPACK FOOTER //
// ./src/utils.js